module.exports = __webpack_public_path__ + "static/media/10.ff71e5a4.JPG";